module.exports = __webpack_public_path__ + "static/media/D3_C4_001.be302355.png";